import { FeatureBase } from '../FeatureBase'
import { GearType, DPIDirect } from '../../types/dpi'

// 扩展功能注册表
declare module '../FeatureMap' {
  export interface DeviceFeatureMap {
    dpi: IDPIFeature
  }
}

export interface IDPIFeature {
  /** 获取所有档位 */
  getGears(configIndex?: number): Promise<GearType[]>
  /** 获取当前档位 */
  getCurrentGear(configIndex?: number): Promise<number>
  /** 获取可用的档位数量 */
  getEnableGear(configIndex?: number): Promise<number>
  /** 设置当前使用档位 */
  setDeviceGear(value: number, configIndex?: number): Promise<void>
  /** 设置档位的DPI */
  setDeviceDPI(index: number, value: number, direct: DPIDirect, configIndex?: number): Promise<void>
  /** 设置所有档位 */
  setDeviceGears(gears: GearType[], configIndex?: number): Promise<void>
}

export class DPIFeature extends FeatureBase implements IDPIFeature {
  getGears(_configIndex?: number): Promise<GearType[]> {
    return this.unsupported('DPIFeature.getGears')
  }
  getCurrentGear(_configIndex?: number): Promise<number> {
    return this.unsupported('DPIFeature.getCurrentGear')
  }
  getEnableGear(_configIndex?: number): Promise<number> {
    return this.unsupported('DPIFeature.getEnableGear')
  }
  setDeviceGear(_value: number, _configIndex?: number): Promise<void> {
    return this.unsupported('DPIFeature.setDeviceGear')
  }
  setDeviceDPI(
    _index: number,
    _value: number,
    _direct: DPIDirect,
    _configIndex?: number,
  ): Promise<void> {
    return this.unsupported('DPIFeature.setDeviceDPI')
  }
  setDeviceGears(_gears: GearType[], _configIndex?: number): Promise<void> {
    return this.unsupported('DPIFeature.setDeviceGears')
  }
}
